import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IContact } from '@leedpulse-monorepo/interfaces';

async function markAsReadAllSMSOfContact(
  contact: IContact,
  auth: Authentication
): Promise<void> {
  try {
    await HttpClient.put(
      `/contact/${contact.id}/sms/readall/backoffice`,
      {},
      auth.token,
      {
        'x-api-key': contact.id_api_key,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new MarkAsReadAllSMSOfContactFailure();
  }
}

export class MarkAsReadAllSMSOfContactFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default markAsReadAllSMSOfContact;
